import React, {useContext, useEffect, useState} from "react"
import AuthContext from "../../context/AuthContext";
import AdminNav from "../../components/AdminNav/AdminNav";
import Loading from "../../components/Loading/Loading";
import useScheduledPostService from "../../api/services/useScheduledPostService";
import useFunction from "../../hooks/useFunction";

const UserAdminAiSocialText = () => {

  const {user} = useContext(AuthContext)
  const [isLoading, setIsLoading] = useState(true)
  const [stands, setStands] = useState([])
  const [spotGroups, setSpotGroups] = useState([])
  const {adminAiTextOverview} = useScheduledPostService()
  const {truncate} = useFunction()

  useEffect(() => {
    adminAiTextOverview(
      (response) => {
        setStands(response.stands || [])
        setSpotGroups(response.spot_groups || [])
        setIsLoading(false)
      },
      (errors) => {
        setIsLoading(false)
      },
    )
  }, []);

  const standsWithText = stands.filter(s => s.ai_social_text)
  const spotGroupsWithText = spotGroups.filter(s => s.ai_social_text)

  const getRowStyle = (hasText) => {
    return {
      backgroundColor: hasText ? '#eaffea' : '#ffecec',
      borderBottom: '1px solid #ddd',
    }
  }

  const getIndicator = (hasText) => {
    return (
      <span style={{
        display: 'inline-block',
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        backgroundColor: hasText ? '#5cb85c' : '#d9534f',
        marginRight: '5px',
      }}/>
    )
  }

  return (
    <div className="page-user-admin">
      {user && user.is_admin &&
        <>
          <AdminNav/>
          <h2>AI Social Teksten Overzicht</h2>

          {isLoading
            ? <Loading/>
            : <>
              <div className="form-row" style={{gap: '30px', marginBottom: '30px'}}>
                <div style={{padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px', flex: 1}}>
                  <strong>Stands:</strong> {standsWithText.length}/{stands.length} hebben AI tekst
                  <div style={{
                    marginTop: '5px',
                    height: '6px',
                    backgroundColor: '#ddd',
                    borderRadius: '3px',
                    overflow: 'hidden',
                  }}>
                    <div style={{
                      height: '100%',
                      width: stands.length > 0 ? (standsWithText.length / stands.length * 100) + '%' : '0%',
                      backgroundColor: '#5cb85c',
                      borderRadius: '3px',
                    }}/>
                  </div>
                </div>
                <div style={{padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px', flex: 1}}>
                  <strong>SpotGroups:</strong> {spotGroupsWithText.length}/{spotGroups.length} hebben AI tekst
                  <div style={{
                    marginTop: '5px',
                    height: '6px',
                    backgroundColor: '#ddd',
                    borderRadius: '3px',
                    overflow: 'hidden',
                  }}>
                    <div style={{
                      height: '100%',
                      width: spotGroups.length > 0 ? (spotGroupsWithText.length / spotGroups.length * 100) + '%' : '0%',
                      backgroundColor: '#5cb85c',
                      borderRadius: '3px',
                    }}/>
                  </div>
                </div>
              </div>

              <h3>Stands ({stands.length})</h3>
              {stands.length === 0
                ? <p>Geen stands gevonden.</p>
                : <div style={{overflowX: 'auto', marginBottom: '30px'}}>
                  <table style={{width: '100%', borderCollapse: 'collapse'}}>
                    <thead>
                      <tr style={{borderBottom: '2px solid #ddd', textAlign: 'left'}}>
                        <th style={{padding: '8px'}}>ID</th>
                        <th style={{padding: '8px'}}>Label</th>
                        <th style={{padding: '8px'}}>Beschrijving</th>
                        <th style={{padding: '8px'}}>Industries</th>
                        <th style={{padding: '8px'}}>AI Tekst</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stands.map((stand) => (
                        <tr key={stand.id} style={getRowStyle(!!stand.ai_social_text)}>
                          <td style={{padding: '8px'}}>{stand.id}</td>
                          <td style={{padding: '8px'}}><strong>{stand.label || '-'}</strong></td>
                          <td style={{padding: '8px', maxWidth: '250px'}}>
                            {stand.description ? truncate(stand.description, 80) : '-'}
                          </td>
                          <td style={{padding: '8px'}}>
                            {stand.industries && stand.industries.length > 0
                              ? stand.industries.map(i => i.label || i.name || i).join(', ')
                              : '-'
                            }
                          </td>
                          <td style={{padding: '8px', maxWidth: '300px'}}>
                            {getIndicator(!!stand.ai_social_text)}
                            {stand.ai_social_text ? truncate(stand.ai_social_text, 80) : 'Geen'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              }

              <h3>SpotGroups ({spotGroups.length})</h3>
              {spotGroups.length === 0
                ? <p>Geen spotgroups gevonden.</p>
                : <div style={{overflowX: 'auto'}}>
                  <table style={{width: '100%', borderCollapse: 'collapse'}}>
                    <thead>
                      <tr style={{borderBottom: '2px solid #ddd', textAlign: 'left'}}>
                        <th style={{padding: '8px'}}>ID</th>
                        <th style={{padding: '8px'}}>Label</th>
                        <th style={{padding: '8px'}}>Beschrijving</th>
                        <th style={{padding: '8px'}}>Types</th>
                        <th style={{padding: '8px'}}>AI Tekst</th>
                      </tr>
                    </thead>
                    <tbody>
                      {spotGroups.map((spotGroup) => (
                        <tr key={spotGroup.id} style={getRowStyle(!!spotGroup.ai_social_text)}>
                          <td style={{padding: '8px'}}>{spotGroup.id}</td>
                          <td style={{padding: '8px'}}><strong>{spotGroup.label || '-'}</strong></td>
                          <td style={{padding: '8px', maxWidth: '250px'}}>
                            {spotGroup.description ? truncate(spotGroup.description, 80) : '-'}
                          </td>
                          <td style={{padding: '8px'}}>
                            {spotGroup.types && spotGroup.types.length > 0
                              ? spotGroup.types.map(t => t.label || t.name || t).join(', ')
                              : '-'
                            }
                          </td>
                          <td style={{padding: '8px', maxWidth: '300px'}}>
                            {getIndicator(!!spotGroup.ai_social_text)}
                            {spotGroup.ai_social_text ? truncate(spotGroup.ai_social_text, 80) : 'Geen'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              }
            </>
          }
        </>
      }
    </div>
  )
}

export default UserAdminAiSocialText
